<div class="row col-12 p-0 m-0 main-page-section ">
  <!-- <div class="p-0">
            <app-side-nav [item]="meetingNav"></app-side-nav>
        </div> -->
  <div class="col-12 p-0">
    <!-- <app-header></app-header> -->
    <div class="col-height">

      <div class="detail-layout">
        <div class="employee-detail">

          <div class="breadcrumbs-section pl-2 ml-5">
            <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
            <img src="../../assets/images/seperator.png">
            <span class="prev-page pr-2 pl-2 prev" routerLink="/company">Companies</span>
            <img src="../../assets/images/seperator.png">
            <span class="curr-page pl-2 breadcrumbs-section-font current">Company Details</span>
          </div>

          <div class="row" *ngIf="!blockedContact">
            <div class="col-6">
              <div class="row">
                <div class="col-8">
                  <h1>Company Details</h1>
                </div>
                <div class="col-4 pt-2"><button>Edit Details</button></div>
              </div>
              <div class="row mt-4">
                <div class="col-8">
                  <div class="title ">Company Name
                  </div>
                  <div class="result">Shama</div>
                </div>
                <div class="col-4">
                  <div class="title">Official Website</div>
                  <div class="result">Internal</div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-8">
                  <div class="title">Building Name</div>
                  <div class="result">Shama</div>
                </div>
              </div>
            </div>
            <div class="col-6"></div>
          </div>


          <div *ngIf="blockedContact">
            <div class="row">
              <div class="col-9">
                <h1>Employee Details</h1>
              </div>
              <div class="col-3 pt-2"><button>Edit Details</button></div>
            </div>
            <div class="row">
              <div class="col-9">
                <div class="row mt-4">
                  <div class="col-5">
                    <div class="title">Employee Name
                      <span class="blocked pl-2">Blocked on 12 Mar, 2021</span>
                    </div>
                    <div class="result">Shama</div>
                  </div>
                  <div class="col-7">
                    <div class="title">Employee Type</div>
                    <div class="result">Internal</div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-5">
                    <div class="title">Email ID</div>
                    <div class="result">Shama&#64;gmail.com</div>
                  </div>
                  <div class="col-7">
                    <div class="title">Mobile Number</div>
                    <div class="result">+91 9999999999</div>
                  </div>
                </div>
              </div>
              <div class="col-1 mt-3 pt-4 pl-3  profile-icon">
                SH
              </div>
              <div class="col-2"></div>
            </div>
          </div>

        </div>



        <div class="content-layout" *ngIf="verified||notVerified">

          <div class="row mt-3">
            <div class="col-12">
              <h1>Building Access</h1>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-2">
              <div class="accessType ">Creator</div>
            </div>
          </div>

          <hr>

          <div class="row">
            <div class="col-4">
              <h2>VMS Invitation Right</h2>
            </div>
            <div class="col-1" *ngIf="!verified">
              <label>
                <input style="display: none;" type="checkbox" (change)="toggleSelection($event)"
                  (ngModelChange)="toggleSelection($event)">
                <span class="slider round toggle-placement"></span>
              </label>
            </div>
            <div class="col-2"><button *ngIf="enableInvite" class="pt-2 mt-1">Select All</button></div>
          </div>

          <div class="row">
            <div class="col-12">
              <p>This will enable employees to invite guests into the selected buildings1</p>
            </div>
          </div>


          <div class="row mt-2" *ngIf="enableInvite||verified">
            <div class="col-2">
              <div class="accessType ">Creator</div>
            </div>
          </div>

        </div>


      </div>


      <!-- <app-footer></app-footer> -->


    </div>
  </div>
